export default "__VITE_ASSET__b0fbcb96__"